import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { AUTHENTICATED_ENTRY, AUTHENTICATED_PANEL_ENTRY } from 'configs/AppConfig';

const PublicRoute = () => {
	const { token, panelToken, userType } = useSelector((state) => state.auth);

	if (token && userType === 'THIRD_PARTY') {
		return <Navigate to="/third-party-report" replace />;
	}

	return token
		? <Navigate to={AUTHENTICATED_ENTRY} />
		: panelToken
			? <Navigate to={AUTHENTICATED_PANEL_ENTRY} />
			: <Outlet />;
};

export default PublicRoute;
